import React, { useState } from 'react';
import GConf from '../AssetsM/generalConf';
import axios from 'axios';
import { Button, Input, Dropdown } from 'semantic-ui-react';
function AddEtudiantCard() {

    let [etudiantData, setEtudiantData] = useState([]);


    const SaveEtudiantFunction = () => {
        if (!etudiantData.e_nom) {alert('nom')} 
        else if (!etudiantData.e_email) {alert('email ')}
        else if (!etudiantData.e_groupe) {alert('matiere')}
        else {
            axios.post(`${GConf.ApiLink}/Admin/add-etudiant`, {
                etudiantData : etudiantData
            })
            .then(function (response) {
                
                 alert('Saved')
            })
        }
    }

    return ( <>
            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Nom du Etudiant : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setEtudiantData({...etudiantData, e_nom: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> E-mail du Etudiant : </h5>
            <Input  icon='mail' iconPosition='left' placeholder='Email .. ' className='shadow-sm w-100' onChange={(e) => setEtudiantData({...etudiantData, e_email: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Groupe : </h5>
            {/* <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setEtudiantData({...etudiantData, e_groupe: e.target.value })}/> */}
            <Dropdown
                search
                selection
                wrapSelection={false}
                options={GConf.groupeListe.map((data, index) => ({id : index, value: data.grid, text:`${data.spec} - ${data.grp} ` }))}
                placeholder='Selectionnez Groupe'
                className='mb-1 shadow-sm w-100'
                onChange={(e, { value }) => setEtudiantData({...etudiantData, e_groupe: value })}
                value={etudiantData.e_groupe}
            />
            <div className='mb-3 mt-3'>
                <Button onClick={() => SaveEtudiantFunction()}  style={{backgroundColor: '#03a561', color:'white'}} className='shadow-sm w-100'> Enregistrer ce Etudiant </Button>
            </div>
    </> );
}

export default AddEtudiantCard;